'use client';

import { Button, Box } from '@mui/material';
import { useTranslations } from 'next-intl';

interface CookieActionsProps {
  onReject: () => void;
  onSave: () => void;
}

export default function CookieActions({ onReject, onSave }: CookieActionsProps) {
  const t = useTranslations('Legal.Cookies.buttons');

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2,
      justifyContent: 'flex-end',
      mt: 4,
      pt: 4
    }}>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={onSave}
        sx={{ textTransform: 'none' }}
      >
        {t('save')}
      </Button>
    </Box>
  );
}
